module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_14_3.ab732868.jpeg";